(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hanogram-auto-discount"] && !Shopify.designMode) return;
  try {
    (function () {
    var config = document.querySelector('[data-hanogram-discount-config]');
    if (!config || window.HanogramAutoDiscount) return;

    var defaultMoneyFormat = '$' + '{' + '{amount}' + '}';
    var moneyFormat = config.dataset.moneyFormat || defaultMoneyFormat;
    var currency = config.dataset.currency || '';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var refreshTimer;

    function escapeHtml(value) {
      return String(value).replace(/[&<>'"]/g, function (character) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character];
      });
    }

    function formatWithDelimiter(number, precision, thousands, decimal) {
      var value = (number / 100).toFixed(precision).split('.');
      value[0] = value[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return value[0] + (value[1] ? decimal + value[1] : '');
    }

    function money(cents) {
      var match = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
      var token = match ? match[1] : 'amount';
      var formatted;

      if (token === 'amount_no_decimals') formatted = formatWithDelimiter(cents, 0, ',', '.');
      else if (token === 'amount_with_comma_separator') formatted = formatWithDelimiter(cents, 2, '.', ',');
      else if (token === 'amount_no_decimals_with_comma_separator') formatted = formatWithDelimiter(cents, 0, '.', ',');
      else formatted = formatWithDelimiter(cents, 2, ',', '.');

      return moneyFormat.replace(match ? match[0] : defaultMoneyFormat, formatted);
    }

    function automaticDiscounts(cart) {
      var discounts = {};
      function add(title, amount) {
        var name = String(title || 'Automatic discount');
        discounts[name] = (discounts[name] || 0) + Number(amount || 0);
      }
      (cart.cart_level_discount_applications || []).forEach(function (application) {
        add(application.title, application.total_allocated_amount);
      });
      (cart.items || []).forEach(function (item) {
        (item.discounts || []).forEach(function (discount) {
          add(discount.title, discount.amount);
        });
      });
      return Object.keys(discounts).map(function (title) {
        return { title: title, amount: discounts[title] };
      }).filter(function (discount) { return discount.amount > 0; });
    }

    function summaryHtml(cart, discounts) {
      var original = Number(cart.original_total_price || cart.items_subtotal_price || 0);
      var total = Number(cart.total_price || 0);
      var currencySuffix = currency ? ' ' + escapeHtml(currency) : '';
      var discountRows = discounts.map(function (discount) {
        return '<div class="hanogram-discount-summary__row">' +
          '<span class="hanogram-discount-summary__label hanogram-discount-summary__tag">' +
            escapeHtml(discount.title) + '</span>' +
          '<span class="hanogram-discount-summary__value">-' + money(discount.amount) + '</span>' +
        '</div>';
      }).join('');

      return '<div class="hanogram-discount-summary__row">' +
        '<span class="hanogram-discount-summary__label">Subtotal</span>' +
        '<span class="hanogram-discount-summary__value">' + money(original) + '</span>' +
      '</div>' + discountRows +
      '<div class="hanogram-discount-summary__row hanogram-discount-summary__total">' +
        '<span class="hanogram-discount-summary__label">EST. TOTAL</span>' +
        '<span class="hanogram-discount-summary__value"><span class="hanogram-discount-summary__was">' +
          money(original) + '</span>' + money(total) + currencySuffix + '</span>' +
      '</div>';
    }

    function checkoutButtons() {
      return Array.prototype.slice.call(document.querySelectorAll(
        'button[name="checkout"], input[name="checkout"], a[href^="/checkout"], a[href*="/checkout"]'
      )).filter(function (button) {
        var isCheckoutLink = button.matches('a[href^="/checkout"], a[href*="/checkout"]');
        var isCartSurface = button.closest(
          '[class*="cart"], [class*="Cart"], [class*="drawer"], [class*="Drawer"], ' +
          '[class*="mini"], [class*="Mini"], form[action*="/cart"]'
        );
        if (isCheckoutLink && !isCartSurface) return false;
        return !button.closest('.hanogram-discount-summary');
      });
    }

    function render(cart) {
      var discounts = automaticDiscounts(cart);
      var visible = discounts.length > 0;
      var buttons = checkoutButtons();

      buttons.forEach(function (button, index) {
        var parent = button.parentElement;
        if (!parent) return;
        var summary = parent.querySelector(':scope > .hanogram-discount-summary');
        if (!summary) {
          summary = document.createElement('div');
          summary.className = 'hanogram-discount-summary';
          summary.dataset.hanogramDiscountSummary = String(index);
          summary.setAttribute('aria-live', 'polite');
          parent.insertBefore(summary, button);
        }
        summary.hidden = !visible;
        if (visible) summary.innerHTML = summaryHtml(cart, discounts);

        var nativeSummary = parent.querySelector(':scope > .tt-shopcart-table01');
        if (nativeSummary) nativeSummary.hidden = visible;
      });
    }

    function getCart() {
      return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (response) {
        if (!response.ok) throw new Error('Unable to load cart');
        return response.json();
      });
    }

    function refresh() {
      window.clearTimeout(refreshTimer);
      refreshTimer = window.setTimeout(function () {
        getCart().then(render).catch(function () {
          /* Keep the native cart usable if the optional enhancement fails. */
        });
      }, 80);
    }

    var nativeFetch = window.fetch;
    window.fetch = function () {
      var request = arguments[0];
      var url = typeof request === 'string' ? request : (request && request.url) || '';
      return nativeFetch.apply(this, arguments).then(function (response) {
        if (/\/cart\/(add|change|update|clear)\.js(?:\?|$)/.test(url)) refresh();
        return response;
      });
    };

    document.addEventListener('change', function (event) {
      if (event.target.closest('form[action*="/cart"]')) refresh();
    });
    document.addEventListener('submit', function (event) {
      if (event.target.matches('form[action*="/cart"]')) refresh();
    });
    document.addEventListener('cart:refresh', refresh);
    document.addEventListener('cart:updated', refresh);

    var observer = new MutationObserver(function () {
      if (checkoutButtons().some(function (button) {
        return !button.parentElement.querySelector(':scope > .hanogram-discount-summary');
      })) refresh();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    window.HanogramAutoDiscount = { refresh: refresh };
    refresh();
  }());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hanogram-collection-controls"] && !Shopify.designMode) return;
  try {
    (() => {
    const roots = document.querySelectorAll('[data-hc-root]');

    roots.forEach((root) => {
      if (root.dataset.hcReady === 'true') return;
      root.dataset.hcReady = 'true';

      const closeDialog = (dialog) => {
        if (!dialog || !dialog.open) return;
        dialog.close();
      };

      root.querySelectorAll('[data-hc-open]').forEach((button) => {
        button.addEventListener('click', () => {
          const dialog = root.querySelector(`[data-hc-dialog="${button.dataset.hcOpen}"]`);
          if (!dialog) return;
          dialog.showModal();
          document.documentElement.classList.add('hc-lock');
          const focusTarget = dialog.querySelector('input, button, a');
          if (focusTarget) window.setTimeout(() => focusTarget.focus(), 40);
        });
      });

      root.querySelectorAll('[data-hc-dialog]').forEach((dialog) => {
        dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('hc-lock');
        });

        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) closeDialog(dialog);
        });

        dialog.querySelectorAll('[data-hc-close]').forEach((button) => {
          button.addEventListener('click', () => closeDialog(dialog));
        });
      });

      const summary = root.querySelector('[data-hc-summary]');
      const summaryToggle = root.querySelector('[data-hc-summary-toggle]');
      if (summary && summaryToggle) {
        const summaryText = summary.querySelector('p');
        const moreLabel = summaryToggle.querySelector('[data-hc-more]');
        const lessLabel = summaryToggle.querySelector('[data-hc-less]');
        const desktopMore = moreLabel.textContent;
        const desktopLess = lessLabel.textContent;
        const updateSummaryToggle = () => {
          if (!summaryText) return;
          const mobile = window.matchMedia('(max-width: 749px)').matches;
          moreLabel.textContent = root.dataset.collectionUrl === '/collections/halloween-collection' ? 'View More' : mobile ? 'Show more' : desktopMore;
          lessLabel.textContent = root.dataset.collectionUrl === '/collections/halloween-collection' ? 'View Less' : mobile ? 'Show less' : desktopLess;
          const wasExpanded = summary.classList.contains('is-expanded');
          summary.classList.remove('is-expanded');
          const needsToggle = summaryText.scrollHeight > summaryText.clientHeight + 1;
          summary.classList.toggle('is-expanded', wasExpanded && needsToggle);
          summaryToggle.hidden = !needsToggle;

          if (!needsToggle) {
            summaryToggle.setAttribute('aria-expanded', 'false');
            summaryToggle.querySelector('[data-hc-more]').hidden = false;
            summaryToggle.querySelector('[data-hc-less]').hidden = true;
          }
        };

        window.requestAnimationFrame(updateSummaryToggle);
        window.addEventListener('resize', updateSummaryToggle, { passive: true });

        summaryToggle.addEventListener('click', () => {
          const expanded = summaryToggle.getAttribute('aria-expanded') === 'true';
          summaryToggle.setAttribute('aria-expanded', String(!expanded));
          summary.classList.toggle('is-expanded', !expanded);
          summaryToggle.querySelector('[data-hc-more]').hidden = !expanded;
          summaryToggle.querySelector('[data-hc-less]').hidden = expanded;
        });
      }

      const search = root.querySelector('[data-hc-model-search]');
      if (search) {
        search.addEventListener('input', () => {
          const term = search.value.trim().toLowerCase();
          let visible = 0;
          root.querySelectorAll('[data-hc-model]').forEach((model) => {
            const matches = model.dataset.hcModel.includes(term);
            model.hidden = !matches;
            if (matches) visible += 1;
          });
          const empty = root.querySelector('[data-hc-model-empty]');
          if (empty) empty.hidden = visible !== 0;
        });
      }

      const currentModelDisplay = root.querySelector('[data-hc-current-model]');
      const modelLinks = [...root.querySelectorAll('[data-hc-model-label]')];
      const modelLabels = modelLinks.map((model) => model.dataset.hcModelLabel);
      const modelFromUrl = new URL(window.location.href).searchParams.get('model');
      const modelFromPage = currentModelDisplay ? currentModelDisplay.textContent.trim() : '';
      const currentModel = modelLabels.includes(modelFromUrl)
        ? modelFromUrl
        : modelLabels.includes(modelFromPage)
          ? modelFromPage
          : '';

      if (currentModel) {
        if (currentModelDisplay) currentModelDisplay.textContent = currentModel;
        modelLinks.forEach((model) => {
          const selected = model.dataset.hcModelLabel === currentModel;
          model.classList.toggle('is-selected', selected);
          const selectedLabel = model.querySelector('[data-hc-model-selected]');
          if (selectedLabel) selectedLabel.hidden = !selected;
        });
      }

      const caseSelect = root.querySelector('[data-hc-case-select]');
      const caseDetails = root.querySelector('[data-hc-case-details]');
      const caseCards = [...root.querySelectorAll('[data-hc-case-card]')];
      const isIphone12To16 = /^iPhone (12|13|14|15|16)(\s|$)/.test(currentModel);
      const iphoneProReferenceModels = new Set([
        'iPhone 14 Pro Max',
        'iPhone 14 Pro',
        'iPhone 13 Pro Max',
        'iPhone 13 Pro',
        'iPhone 12 Pro Max',
        'iPhone 12 Pro',
      ]);
      const iphoneDeviceCaseTypeModels = new Set([
        'iPhone 16 Pro Max',
        'iPhone 16 Pro',
        'iPhone 15 Pro Max',
        'iPhone 15 Pro',
        'iPhone 14 Pro Max',
        'iPhone 14 Pro',
        'iPhone 13 Pro Max',
        'iPhone 13 Pro',
        'iPhone 12 Pro Max',
        'iPhone 12 Pro',
      ]);
      const iphoneDeviceCaseTypeSuffixes = new Map([
        ['Ultra Clear Case', 'ultra-clear-cases'],
        ['MagSafe Compatible Ultra Clear Case', 'magsafe-compatible-ultra-clear-cases'],
        ['Mirror Case', 'mirror-cases'],
        ['MagSafe Compatible Mirror Case', 'magsafe-compatible-mirror-cases'],
      ]);
      const iphoneStandardReferenceModels = new Set([
        'iPhone 13',
        'iPhone 13 Mini',
        'iPhone 12',
        'iPhone 12 Mini',
      ]);
      const currentCaseDisplay = root.querySelector('[data-hc-current-case]');
      const caseControl = root.querySelector('[data-hc-open="case"]');
      const applyModelPageCopy = () => {
        if (!modelFromUrl || modelFromUrl !== currentModel || currentModel === modelFromPage) return;

        const specificModelPattern = /\biPhone (?:Air|1[1-8](?: Pro Max| Pro| Plus| Mini)?)\b/i;
        const adaptCopy = (value) => {
          if (!value) return value;
          if (specificModelPattern.test(value)) {
            return value.replace(new RegExp(specificModelPattern.source, 'gi'), currentModel);
          }
          return value.replace(/\biPhone\b/i, currentModel);
        };
        const heroTitle = root.querySelector('.hc__title');
        const summaryParagraph = root.querySelector('[data-hc-summary] p');
        const isPoolB = root.dataset.collectionUrl === '/collections/iphone-mirror-cases';
        const sourceTitle = heroTitle ? heroTitle.textContent.trim() : '';
        const displayTitle = isPoolB
          ? currentModel + root.dataset.hcModelTitleSuffix
          : adaptCopy(sourceTitle) || `${currentModel} Cases`;

        if (heroTitle) heroTitle.textContent = displayTitle;
        if (summaryParagraph) {
          const sourceSummary = summaryParagraph.textContent.trim();
          const displaySummary = isPoolB
            ? root.dataset.hcModelSummaryPrefix + currentModel + root.dataset.hcModelSummarySuffix
            : adaptCopy(sourceSummary);
          if (displaySummary !== sourceSummary) summaryParagraph.textContent = displaySummary;
        }

        document.title = adaptCopy(document.title);
        document.querySelectorAll([
          'meta[name="description"]',
          'meta[property="og:title"]',
          'meta[property="og:description"]',
          'meta[name="twitter:title"]',
          'meta[name="twitter:description"]',
        ].join(',')).forEach((meta) => {
          meta.content = adaptCopy(meta.content);
        });

        const currentBreadcrumb = document.querySelector('.tt-breadcrumb li:last-child');
        if (currentBreadcrumb) currentBreadcrumb.textContent = displayTitle;
        window.requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
      };
      const applySelectedProductVariants = () => {
        if (!/^iPhone (12|13|14|15|16)(\s|$)/.test(currentModel)) return;
        const selectedCaseType = currentCaseDisplay ? currentCaseDisplay.textContent.trim() : '';
        document.querySelectorAll('.tt-product-listing .tt-col-item[data-hc-model-variants]').forEach((item) => {
          const variants = item.dataset.hcModelVariants.split('|').map((entry) => {
            const [id, device, caseType, available] = entry.split('::');
            return { id, device, caseType, available: available === 'true' };
          });
          const matchingDevice = variants.filter((variant) => (
            variant.available && variant.device.toLowerCase() === currentModel.toLowerCase()
          ));
          const selectedVariant = matchingDevice.find((variant) => variant.caseType === selectedCaseType)
            || matchingDevice.find((variant) => !variant.caseType)
            || matchingDevice[0];
          if (!selectedVariant) return;

          item.querySelectorAll('a[href*="/products/"]').forEach((link) => {
            const productUrl = new URL(link.href, window.location.origin);
            productUrl.searchParams.set('variant', selectedVariant.id);
            link.href = productUrl.toString();
          });
          item.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach((input) => {
            input.value = selectedVariant.id;
          });
          item.querySelectorAll('[data-firstavavariantid]').forEach((quickView) => {
            quickView.dataset.firstavavariantid = selectedVariant.id;
          });
        });
      };
      const setModelFamilyImage = (image, label, source) => {
        if (!image || !source) return;
        image.src = source;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.alt = `${currentModel} ${label}`;
      };

      if (isIphone12To16) {
        caseCards.forEach((card) => {
          const source = currentModel.includes('Pro') || iphoneProReferenceModels.has(currentModel)
            ? card.dataset.hcProImage
            : card.dataset.hcStandardImage;
          setModelFamilyImage(card.querySelector('img'), card.dataset.label, source);
        });
      }

      const caseUrl = (card) => {
        const url = new URL(card.dataset.url, window.location.origin);
        const deviceCaseTypeSuffix = iphoneDeviceCaseTypeSuffixes.get(card.dataset.label);
        if (iphoneDeviceCaseTypeModels.has(currentModel) && deviceCaseTypeSuffix) {
          const deviceHandle = currentModel.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
          url.pathname = `/collections/${deviceHandle}-${deviceCaseTypeSuffix}`;
        } else if (card.dataset.label === 'Ultra Clear Case') {
          if (iphoneProReferenceModels.has(currentModel)) {
            url.pathname = '/collections/iphone-15-pro-max-cases';
          } else if (iphoneStandardReferenceModels.has(currentModel)) {
            url.pathname = '/collections/iphone-clear-case';
          } else if (/^iPhone 14(\s|$)/.test(currentModel)) {
            url.pathname = '/collections/iphone-ultra-clear-cases';
          }
        }
        if (currentModel) {
          url.searchParams.set('model', currentModel);
        }
        return url.toString();
      };
      const selectCaseCard = (card) => {
        caseCards.forEach((item) => {
          item.classList.remove('is-selected');
          item.setAttribute('aria-pressed', 'false');
        });
        card.classList.add('is-selected');
        card.setAttribute('aria-pressed', 'true');
        if (caseSelect) caseSelect.href = caseUrl(card);
        if (currentCaseDisplay) currentCaseDisplay.textContent = card.dataset.label;
        const cardImage = card.querySelector('img');
        if (caseControl && cardImage) {
          let controlImage = caseControl.querySelector('.hc-control__thumb');
          if (!controlImage) {
            controlImage = document.createElement('img');
            controlImage.className = 'hc-control__thumb';
            controlImage.width = 48;
            controlImage.height = 48;
            controlImage.loading = 'lazy';
            caseControl.prepend(controlImage);
          }
          controlImage.src = cardImage.currentSrc || cardImage.src;
          controlImage.removeAttribute('srcset');
          controlImage.removeAttribute('sizes');
          controlImage.alt = `${currentModel ? `${currentModel} ` : ''}${card.dataset.label}`;
        }
        const copyTemplate = document.getElementById(card.dataset.copyTemplate);
        if (caseDetails && copyTemplate) {
          caseDetails.replaceChildren(copyTemplate.content.cloneNode(true));
        }
      };

      if (currentModel) {
        caseCards.forEach((card) => {
          const compatibleModels = card.dataset.compatibleModels
            ? card.dataset.compatibleModels.split('|')
            : [];
          card.hidden = Boolean(currentModel && compatibleModels.length && !compatibleModels.includes(currentModel));
        });
        const selectedCase = caseCards.find((card) => card.classList.contains('is-selected') && !card.hidden);
        const fallbackCase = caseCards.find((card) => !card.hidden);
        if (selectedCase || fallbackCase) selectCaseCard(selectedCase || fallbackCase);
        applyModelPageCopy();
        applySelectedProductVariants();
      }

      caseCards.forEach((card) => {
        card.addEventListener('click', () => {
          selectCaseCard(card);
        });
      });

      root.querySelectorAll('[data-hc-filter-more]').forEach((button) => {
        button.addEventListener('click', () => {
          const values = button.parentElement.querySelector('[data-hc-filter-values]');
          const expanded = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', String(!expanded));
          values.classList.toggle('is-expanded', !expanded);
          button.textContent = expanded ? button.dataset.moreLabel : button.dataset.lessLabel;
        });
      });

      const filterForm = root.querySelector('[data-hc-filter-form]');
      if (filterForm) {
        const filterClear = filterForm.querySelector('[data-hc-filter-clear]');
        if (filterClear && currentModel) {
          const clearUrl = new URL(filterClear.href);
          clearUrl.searchParams.set('model', currentModel);
          filterClear.href = clearUrl.toString();
        }
        filterForm.addEventListener('submit', (event) => {
          event.preventDefault();
          const params = new URLSearchParams(new FormData(filterForm));
          if (currentModel) {
            params.set('model', currentModel);
          }
          const selectedTags = [...filterForm.querySelectorAll('[data-hc-tag]:checked')]
            .map((input) => encodeURIComponent(input.value));
          params.delete('page');
          const query = params.toString();
          const path = selectedTags.length
            ? `${root.dataset.collectionUrl}/${selectedTags.join('+')}`
            : root.dataset.collectionUrl;
          window.location.assign(`${path}${query ? `?${query}` : ''}`);
        });
      }

      root.querySelectorAll('[data-hc-sort]').forEach((radio) => {
        radio.addEventListener('change', () => {
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', radio.value);
          url.searchParams.delete('page');
          window.location.assign(url.toString());
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hanogram-numbered-pagination"] && !Shopify.designMode) return;
  try {
    (() => {
  if (!document.querySelector('[data-hg-numbered-pagination]')) return;
  const storageKey = () => 'hg-collection-position:' + location.pathname + location.search;
  const save = () => {
    try { sessionStorage.setItem(storageKey(), JSON.stringify({ y: window.scrollY, time: Date.now() })); } catch (_) {}
  };
  document.querySelectorAll('.hg-pages a').forEach(link => {
    const url = new URL(location.href);
    const destination = new URL(link.href);
    url.searchParams.set('page', destination.searchParams.get('page') || '1');
    url.hash = '';
    link.href = url.href;
  });
  document.addEventListener('click', event => {
    if (event.target.closest('a[href*="/products/"]')) save();
  }, true);
  window.addEventListener('pagehide', save);
  const restore = event => {
    const navigation = performance.getEntriesByType('navigation')[0];
    if (!(event && event.persisted) && (!navigation || navigation.type !== 'back_forward')) return;
    let saved;
    try { saved = JSON.parse(sessionStorage.getItem(storageKey())); } catch (_) { return; }
    if (!saved || Date.now() - saved.time > 3600000) return;
    let cancelled = false;
    const cancel = () => { cancelled = true; };
    ['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach(name => window.addEventListener(name, cancel, { once: true, passive: true }));
    [0, 100, 300, 700, 1200].forEach(delay => window.setTimeout(() => {
      if (!cancelled) window.scrollTo({ top: saved.y, behavior: 'instant' });
    }, delay));
  };
  window.addEventListener('pageshow', restore);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hanogram-product-options"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.hanogramProductOptionsInitialized) return;
    window.hanogramProductOptionsInitialized = true;

    const container = document.querySelector('[data-hanogram-product-options]');
    if (!container) return;
    const dataElement = container.querySelector('[data-hanogram-option-data]');
    let matchingSets = [];

    try {
      matchingSets = JSON.parse(dataElement?.textContent || '[]').filter(Boolean);
    } catch (error) {
      matchingSets = [];
    }
    dataElement?.remove();

    const appendField = (input, optionSetIndex, inputIndex) => {
      const { property, label: labelText, required, placeholder, choices, maxLength } = input;
      const fieldId = 'hanogram-option-' + optionSetIndex + '-' + inputIndex;
      const field = document.createElement('div');
      field.className = 'form-group hanogram-option-field';
      field.dataset.hanogramOptionSetIndex = String(optionSetIndex);
      field.dataset.hanogramInputIndex = String(inputIndex);
      const label = document.createElement('label');
      const span = document.createElement('span');
      label.htmlFor = fieldId;
      label.className = 'spb-productdescfont spb-productdesctextcolor';
      label.textContent = labelText;
      field.append(label, span);

      if (Array.isArray(choices) && choices.length) {
        const wrapper = document.createElement('div');
        const select = document.createElement('select');
        wrapper.className = 'spb-select';
        select.id = fieldId;
        select.className = 'form-control';
        select.name = 'properties[' + property + ']';
        select.required = Boolean(required);
        select.dataset.hanogramOptionProperty = property;
        select.dataset.hanogramRequired = required ? 'true' : 'false';
        if (placeholder) {
          const placeholderOption = document.createElement('option');
          placeholderOption.value = '';
          placeholderOption.textContent = placeholder;
          placeholderOption.disabled = true;
          placeholderOption.selected = true;
          select.append(placeholderOption);
        }
        choices.forEach((value) => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = value;
          select.append(option);
        });
        wrapper.append(select);
        span.append(wrapper);
      } else {
        const inputElement = document.createElement('input');
        inputElement.type = 'text';
        inputElement.id = fieldId;
        inputElement.className = 'spb-productdescfont spb-productoptiontextcolor spb-productoptionbackground';
        inputElement.name = 'properties[' + property + ']';
        inputElement.required = Boolean(required);
        inputElement.dataset.hanogramOptionProperty = property;
        inputElement.dataset.hanogramRequired = required ? 'true' : 'false';
        if (placeholder) inputElement.placeholder = placeholder;
        if (Number(maxLength) > 0) {
          inputElement.maxLength = Number(maxLength);
          inputElement.size = Number(maxLength);
        }
        span.append(inputElement);
      }
      container.append(field);
    };

    matchingSets.forEach((optionSet, optionSetIndex) => {
      (optionSet.fields || []).filter(Boolean).forEach((input, inputIndex) => appendField(input, optionSetIndex, inputIndex));
    });

    const isCustomizationField = (control) => control.dataset.hanogramOptionProperty?.trim().toLowerCase() === 'customize?';
    const isWithoutName = (value) => {
      const normalizedValue = String(value || '').trim().toLowerCase();
      return normalizedValue.startsWith('no') && normalizedValue.includes('without name');
    };
    const setFieldAvailability = (field, hidden) => {
      field.hidden = hidden;
      field.querySelectorAll('input, select, textarea').forEach((control) => {
        control.disabled = hidden;
        control.required = hidden ? false : control.dataset.hanogramRequired === 'true';
        if (hidden) {
          control.value = '';
          control.classList.remove('hanogram-option-invalid');
        }
      });
    };
    const syncCustomizationFields = (customizationSelect) => {
      const customizationField = customizationSelect.closest('.hanogram-option-field');
      if (!customizationField) return;
      const optionSetIndex = customizationField.dataset.hanogramOptionSetIndex;
      const customizationInputIndex = Number(customizationField.dataset.hanogramInputIndex);
      const hideCustomizationFields = isWithoutName(customizationSelect.value);

      container.querySelectorAll('.hanogram-option-field').forEach((field) => {
        const belongsToOptionSet = field.dataset.hanogramOptionSetIndex === optionSetIndex;
        const followsCustomizationField = Number(field.dataset.hanogramInputIndex) > customizationInputIndex;
        if (belongsToOptionSet && followsCustomizationField) setFieldAvailability(field, hideCustomizationFields);
      });
    };

    container.querySelectorAll('select[data-hanogram-option-property]').forEach((select) => {
      if (isCustomizationField(select)) syncCustomizationFields(select);
    });

    container.addEventListener('change', (event) => {
      if (event.target instanceof HTMLSelectElement && isCustomizationField(event.target)) syncCustomizationFields(event.target);
    });

    const mountProductOptions = () => {
      if (!container.querySelector('input, select')) return;
      const forms = document.querySelectorAll('.product_page_template form[action*="/cart/add"]');
      const form = Array.from(forms).find((candidate) => candidate.querySelector('.tt-row-custom-01 .btn-addtocart'));
      if (!form) return;
      form.querySelector('.tt-row-custom-01').before(container);
      container.hidden = false;
    };

    const validateProductOptions = (event, form) => {
      if (!form || !form.querySelector('[data-hanogram-product-options]') || form.checkValidity()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      form.reportValidity();
      form.querySelector('[data-hanogram-product-options] :invalid')?.focus();
    };

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest('.addtocart-js, .shopify-payment-button__button');
      if (button) validateProductOptions(event, button.closest('form'));
    }, true);
    document.addEventListener('submit', (event) => validateProductOptions(event, event.target), true);
    document.addEventListener('invalid', (event) => {
      if (event.target instanceof Element && event.target.closest('[data-hanogram-product-options]')) event.target.classList.add('hanogram-option-invalid');
    }, true);
    document.addEventListener('input', (event) => {
      if (!(event.target instanceof Element)) return;
      if (event.target.matches('[data-hanogram-product-options] input, [data-hanogram-product-options] select') && event.target.checkValidity()) event.target.classList.remove('hanogram-option-invalid');
    }, true);

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountProductOptions, { once: true });
    else mountProductOptions();
  })();
  } catch(e) { console.error(e); }
})();

})();
